import React, { useState } from "react";
import Select from "react-select";
import { BsArrowRight, BsCheck2Circle } from "react-icons/bs";
import { FiAlertCircle } from "react-icons/fi";
import Map from "../assets/map.png";
import Pic from "../assets/blankProf.png";
import emailjs from "@emailjs/browser";
function Contact() {
  const initialstate = {
    name: "",
    reason: "",
    email: "",
  };

  const [inputs, setInputs] = useState(initialstate);
  const [active, setActive] = useState(false);

  const options = [
    {
      label: "Subscription have been cancelled",
      value: "the subscription that have been cancelled",
    },
    {
      label: "Technical difficulties",
      value: "Encountering technical difficulties withing the platform",
    },
  ];

  /**overwriting default styles of the react-select**/
  const customStyles = {
    /**overwrite the text color of the the input**/
    singleValue: (base) => ({ ...base, color: "white" }),
    control: (base, state) => ({
      ...base,
      background: "transparent",
      // Overwrites the focus state of border
      border: "0px",
      borderBottom: "2px",
      width: "280px",
      fontSize: "1.25rem",
      borderColor: state.isFocused ? "#D0AA87" : "#101010",
      // Removes border around container
      boxShadow: state.isFocused ? null : null,
      // overwites the selected option diplayed in the input
      "&:hover": {
        // Overwrites the hover state of border
        borderColor: state.isFocused ? "#D0AA87" : "#D0AA87",
      },
    }),
    option: (styles, { isDisabled, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "red" : "rgb(255 255 255)",
        backgroundColor: isSelected ? "#CCBBAB" : "rgb(255 255 255)",
        color: isSelected ? "#000" : "#000",
        cursor: isDisabled ? "not-allowed" : "pointer",
        "&:hover": {
          background: "#CCBBAB",
          color: "#fff",
        },
      };
    },
  };

  const SendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_5meoak7",
        "template_yh0f9vo",
        e.target,
        "zMfrzHL5TR_aY369X"
      )
      .then(
        (result) => {
          setActive(true);
          setTimeout(() => {
            setActive(false);
          }, 2000);
          setInputs(initialstate);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };

  return (
    <div className="w-full h-screen py-7">
      <div className="font-medium text-lg mt-36 px-20 text-inputLabel ">
        / Get In Touch
      </div>
      <h1 className="font-bold px-20 text-2xl text-zinc-800">
        Send us your inquiry
      </h1>
      <form className="mt-12 px-20 flex flex-col" onSubmit={SendEmail}>
        <div className="flex flex-row items-center">
          <div className="text-2xl text-zinc-800 font-medium">
            Hey, my name is
          </div>
          <input
            className="capitalize bg-transparent mx-4 border-zinc-400 border-b-2 h-10 w-72 text-xl text-zinc-600 focus:outline-none placeholder-shown:text-center "
            type="text"
            name="name"
            onChange={(e) => setInputs({ ...inputs, name: e.target.value })}
            autoComplete="off"
            required
            placeholder="Type Here"
          />
          <div className="text-2xl text-zinc-800 font-medium mr-4">
            And I’m sending this for
          </div>
          <Select
            styles={customStyles}
            options={options}
            name="reason"
            className="border-zinc-400  border-b-2 h-10"
            onChange={(e) => setInputs({ ...inputs, reason: e.value })}
            placeholder="Choose a category..."
          />
        </div>
        <div className="flex flex-row items-center mt-10">
          <div className="text-2xl text-zinc-800 font-medium">
            Get in touch with me at
          </div>
          <input
            className=" bg-transparent mx-4 border-zinc-400 border-b-2 h-10 w-80 text-xl text-zinc-600 focus:outline-none placeholder-shown:text-center "
            type="email"
            pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
            onChange={(e) => setInputs({ ...inputs, email: e.target.value })}
            autoComplete="off"
            required
            name="email_Add"
            placeholder="Your Email Address"
          />
        </div>
        <button
          type="submit"
          id="BTNwrapper"
          className="w-fit self-end mt-7 bg-[#CCBBAB] text-lg overflow-hidden font-semibold text-zinc-800 items-center py-2 px-3 transition-all duration-500 hover:scale-105 hover:bg-DarkBlue rounded-xl"
        >
          <div
            className={
              active
                ? "flex flex-row relative transition-all duration-500 -translate-y-[3.75rem]"
                : "flex flex-row relative transition-all duration-500"
            }
          >
            Send Inquiry <BsArrowRight size={27} className="ml-3" id="text" />
            <div className="absolute left-8 flex flex-row top-10 translate-y-5 text-white">
              <BsCheck2Circle size={25} color="#ffffff" className="mr-2" />
              Sent
            </div>
          </div>
        </button>
      </form>
      <div className="mt-8 mr-20 flex flex-row justify-between">
        <a
          href="https://www.google.com/maps/@35.772731,-5.8169348,17.46z"
          className="rounded-lg transition ease-in-out hover:scale-110 duration-500"
          target="_Blank"
        >
          <img
            src={Map}
            className="w-64 h-32 rounded-lg object-cover border-4"
          />
        </a>
        <div className="flex flex-row items-center">
          <img src={Pic} className="w-16 rounded-lg" />
          <div className="flex flex-col ml-3">
            <div className="font-bold text-zinc-800 ">Ahmad</div>
            <div className="font-medium text-zinc-600">
              Developer & Designer
            </div>
          </div>
        </div>
        <div className="flex flex-col self-center">
          <div className="font-medium text-zinc-600">ouladaouida@gmail.com</div>
          <div className="font-medium text-zinc-600">(212) 645-9623</div>
        </div>
        <div className="flex flex-col self-center">
          <div className="font-medium text-zinc-600">Av. Moulay Youssef</div>
          <div className="font-medium text-zinc-600">
            90060 Tangier, Morocco
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
